import { useCallback, useEffect } from 'react'
import { matchRoutes, Navigate, Outlet, useLocation } from 'react-router-dom'

import { ConfirmationDialog } from '../../../components/ConfirmationDialog'
import { Header } from '../../../components/Header'
import { DialogBoxProvider } from '../../../contexts/dialogBoxContext'
import { PromotersStayingTimeProvider } from '../../../contexts/promotersStayingTimeContext'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { setStateOptionsAction } from '../../../services/appServices'
import { ROLE_PERMISSION, ROUTE_PATTERNS } from '../../../utils/routePermission'
import { Footer } from './Footer'

export function ProtectedRoute() {
  const { isAuthenticated, profile } = useAppSelector(state => state.auth)
  const { isLoading, currentTerms } = useAppSelector(state => state.app)
  const location = useLocation()

  const loadDefaultData = useCallback(async () => {
    await setStateOptionsAction()
  }, [])

  useEffect(() => {
    if (typeof isAuthenticated === 'boolean' && isAuthenticated && !isLoading) {
      loadDefaultData()
    }
  }, [isAuthenticated, isLoading, loadDefaultData])

  if (isLoading) {
    return <h1>Carregando...</h1>
  }

  const matchedRoute = matchRoutes(ROUTE_PATTERNS, location)

  if (!matchedRoute) {
    return <Navigate to="/" replace />
  }

  const allowedRoles = ROLE_PERMISSION[matchedRoute[0].route.path] || []

  if (profile && !allowedRoles.includes(profile.role)) {
    return <Navigate to="/dashboard" />
  }

  if (location.pathname !== '/terms' && profile && (profile.terms_acceptance.length === 0 || profile.terms_acceptance[0].terms.version !== currentTerms.version)) {
    return <Navigate to="/terms" replace />
  }

  return typeof isAuthenticated === 'boolean' && !isAuthenticated
    ? <Navigate to="/" replace />
    : (
      <DialogBoxProvider>
        <PromotersStayingTimeProvider>
          <Header />
          <Outlet />
          <ConfirmationDialog />
          <Footer />
        </PromotersStayingTimeProvider>
      </DialogBoxProvider>
      )
}
